export default __webpack_public_path__ + "static/media/p22.85df41cc.jpg";